import { render, staticRenderFns } from "./EbookHeader.vue?vue&type=template&id=f8bd301c&scoped=true&"
import script from "./EbookHeader.vue?vue&type=script&lang=js&"
export * from "./EbookHeader.vue?vue&type=script&lang=js&"
import style0 from "./EbookHeader.vue?vue&type=style&index=0&id=f8bd301c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bd301c",
  null
  
)

export default component.exports